const VestingTypes = [
  { text: "STANDARD", value: "Standard" },
  { text: "CUSTOM", value: "Custom" },
];
export default VestingTypes;
